export default __webpack_public_path__ + "static/media/route-grid1.a8b9b440.png";